module.exports = __webpack_public_path__ + "static/ImageOurExpertise2-1f9ca82cbf12c79884257876ab043720.jpg";